import {add as addPrintjob} from '../lib/printerqueue';

export default class PrintReceiptEft {
    print(data) {
        // eslint-disable-next-line no-undef
        var builder = new StarWebPrintBuilder();
        // Create Request
        var request = '';

        if (typeof data === 'string') {
            data = JSON.parse(data);
        }

        data.forEach(function (line) {
            request += builder.createTextElement({ data: line + '\n' });
        })

        request += builder.createCutPaperElement({
            feed: true,
            type: 'full',//store.printer.autocutter,
        });

        // add to queue
        addPrintjob(request);

        return;
    }


    format_string(value, length, align = 'left') {
        let str = value.toString();

        while (str.length < length) {
            if (align == 'right') {
                str = ' ' + str;
            } else {
                str = str + ' ';
            }
        }
        if (str.length <= length) {
            return str
        }
        return str.slice(0, length)
        // return string;

    }
}
